import request from '@/utils/request'

// 查询菜单列表
export function listMenu(data) {
    return request({
        url: '/admin/menus/list',
        method: 'post',
        data: data
    })
}

// 查询菜单详细
export function getMenu(menuId) {
    return request({
        url: '/admin/menus/' + menuId,
        method: 'get'
    })
}

// 查询菜单下拉树结构
export function treeselect() {
    return request({
        url: '/admin/menus/treeselect',
        method: 'get'
    })
}

// 根据角色ID查询菜单下拉树结构
export function roleMenuTreeselect(roleId) {
    return request({
        url: '/admin/menus/roleMenuTreeselect/' + roleId,
        method: 'get'
    })
}

// 新增菜单
export function addMenu(data) {
    return request({
        url: '/admin/menus',
        method: 'post',
        data: data
    })
}

// 修改菜单
export function updateMenu(data) {
    return request({
        url: '/admin/menus',
        method: 'put',
        data: data
    })
}

// 删除菜单
export function delMenu(menuId) {
    return request({
        url: '/admin/menus/' + menuId,
        method: 'delete'
    })
}
